export enum STATES {
    WAITING_FOR_OPPONENT,
    WAITING_FOR_CONFIRMATION,
    SEND_START_GAME,
    START_GAME,
}

interface Rematch {
    state: STATES;
    opponentId: string;
    channelId: string;
}

export default Rematch;
